(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["sani-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sani-size-guide')) {
  customElements.define('sani-size-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const dialog = this.querySelector('dialog');
      const trigger = this.querySelector('[data-size-guide-open]');
      if (!dialog || !trigger) return;
      trigger.addEventListener('click', () => dialog.showModal());
      this.querySelector('[data-size-guide-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => trigger.focus({ preventScroll: true }));
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
